
import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ApiResponse, PaginatedResponse } from '../interfaces/api-response.interface';
import { ActivityItem } from '../interfaces/activityItem.interface';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ActivityService {
  private api = inject(ApiService);
  private _activityType$ = new BehaviorSubject<string | null>(null);
  activityType$ = this._activityType$.asObservable();

    setActivities(activityType: string | null) {
    this._activityType$.next(activityType);
  }
  

  getActivities(payload: {pageSize: number, pageNumber: number, sortDirection: string, activityPage: string}): Observable<ApiResponse<PaginatedResponse<ActivityItem>>> {
    return this.api.post<ApiResponse<PaginatedResponse<ActivityItem>>>(`/user-activity/list-activity`, payload);
  }
}
